import { AgGridVue } from 'ag-grid-vue'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import {
  calculateGridHeight,
  evaluateQantity,
  showNotification,
  convertCalculationForTemplateAnalysisSheet,
} from '@/services/calculate'
import {
  projectlockedRow,
  strikeProjectAnalysisCalculations,
} from '@/services/grid'
import { socketEvents, tableName } from '@/services/config'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import NumberRender from '@/components/DynamicComponents/Renderers/numberRenderer'
import exportTemplates from '@/components/DynamicComponents/Projects/Export'
import _ from 'lodash'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    'export-sheet': exportTemplates,
  },
  props: [
    'child',
    'projectData',
    'screenIndentifier',
    'dropdownData',
    'projectModule',
    'type',
    'columnSettings',
    'activeKey',
  ],
  data() {
    return {
      data: [],
      columnDefs: [],
      frameworkComponents: null,
      width: '100%',
      height: '440px',
      loading: false,
      visible: false,
      dropdownInfo: this.dropdownData,
      sideBar: null,
      exportClicked: false,
      url: projectAPIs.project.asset.newConstAnalysisSheet.export(
        this.$route.params.id,
      ),
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: false,
        rowSelection: 'multiple',
        rowDragManaged: true,
        animateRows: true,
        suppressContextMenu: true,
        defaultColDef: {
          sortable: true,
          resizable: true,
          editable: false,
          suppressMovable: true,
          wrapText: true,
          filter: 'customFilter',
          menuTabs: ['filterMenuTab'],
        },
      },
    }
  },
  beforeMount() {
    this.loaderConfig()
    this.postSort = rowNodes => {
      this.sortedData = []
      for (let i = 0; i < rowNodes.length; i++) {
        if (rowNodes[i].data.categoryCode) {
          rowNodes[i].data.categoryCode = Number(rowNodes[i].data.categoryCode)
        }
        this.sortedData.push(rowNodes[i].data)
      }
      this.data = [...this.sortedData]
    }
  },
  watch: {
    activeKey() {
      if (this.activeKey === '2') {
        // this.reconcileSheet()
      }
    },
  },
  mounted() {
    this.getAnalysisSheet()
    // this.reconcileSheet()
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
    this.$root.$off('showDrawer')
    this.$root.$off('gridSizeChange')
    window.addEventListener('resize', this.getWindowSize)
    this.$root.$on('gridSizeChange', this.getWindowSize)
    this.$socketHub.$off('message-received')
    this.$socketHub.$on('message-received', this.messageRecieved)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
    this.$root.$off('showDrawer')
  },
  methods: {
    loaderConfig() {
      this.frameworkComponents = {
        costPriceCellRenderer: CurrencyRenderer,
        customFilter: CustomFilter,
        toolTipRenderer: ToolTipRenderer,
        numberRender: NumberRender,
      }
      this.sideBar = {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressColumnSelectAll: false,
              suppressColumnExpandAll: true,
            },
          },
        ],
        defaultToolPanel: 'columns',
      }
      this.columnDefs = [
        {
          headerName: 'ID',
          headerTooltip: 'ID',
          field: 'sequenceNew',
          headerClass: 'analysis-header-center',
          width: 80,
          cellStyle: params => projectlockedRow(params, 'sequenceNew'),
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          pinned: 'left',
        },
        {
          headerName: 'Asset Number',
          headerTooltip: 'Asset Number',
          headerClass: 'analysis-header',
          field: 'assetNumber',
          sort: 'asc',
          width: 120,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { field: 'assetNumber' },
          cellStyle: params => projectlockedRow(params, 'assetNumber'),
          pinned: 'left',
        },
        {
          headerName: 'Description',
          headerTooltip: 'Description',
          headerClass: 'analysis-header-left',
          field: 'assetDescription',
          width: 150,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { field: 'assetDescription' },
          cellStyle: params =>
            projectlockedRow(params, 'assetDescription', 'left'),
          pinned: 'left',
        },
        {
          headerName: 'Cost Type',
          headerTooltip: 'Cost Type',
          headerClass: 'analysis-header-left',
          field: 'costType',
          width: 150,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          cellStyle: params => projectlockedRow(params, 'costType', 'left'),
          pinned: 'left',
        },
        {
          headerName: 'Estimate Group',
          headerTooltip: 'Estimate Group',
          headerClass: 'analysis-header-left',
          field: 'estimateGroupName',
          width: 150,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          cellStyle: params =>
            projectlockedRow(params, 'estimateGroupName', 'left'),
          pinned: 'left',
        },
        {
          headerName: 'Contract',
          headerTooltip: 'Contract',
          headerClass: 'analysis-header',
          field: 'contract',
          sort: 'asc',
          width: 120,
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'contract',
          },
          cellRenderer: 'toolTipRenderer',
          cellStyle: params => projectlockedRow(params, 'contract', 'left'),
        },
        {
          headerName: 'Contract Name',
          headerTooltip: 'Contract Name',
          headerClass: 'analysis-header-left',
          field: 'contractName',
          width: 150,
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'contractName',
          },
          cellRenderer: 'toolTipRenderer',
          cellStyle: params => projectlockedRow(params, 'contractName', 'left'),
        },
        {
          headerName: 'Category Code',
          headerClass: 'analysis-header',
          headerTooltip: 'Category Code',
          field: 'categoryCode',
          sort: 'asc',
          width: 120,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'categoryCode',
          },
          cellStyle: params => projectlockedRow(params, 'categoryCode', 'left'),
        },
        {
          headerName: 'Category Description',
          headerTooltip: 'Category Description',
          headerClass: 'analysis-header-left',
          field: 'categoryCodeDescription',
          width: 160,
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'categoryCodeDescription',
          },
          cellRenderer: 'toolTipRenderer',
          cellStyle: params =>
            projectlockedRow(params, 'categoryCodeDescription', 'left'),
        },
        {
          headerName: 'Asset Class',
          headerTooltip: 'Asset Class',
          headerClass: 'analysis-header-left',
          field: 'assetClass',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'asset_Class',
          },
          cellStyle: params => projectlockedRow(params, 'assetClass', 'left'),
        },
        {
          headerName: 'Life',
          headerTooltip: 'Life',
          field: 'life',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'life',
          },
          cellStyle: params => projectlockedRow(params, 'life', 'left'),
        },
        {
          headerName: 'Takeoff Grouping',
          headerTooltip: 'Takeoff Grouping',
          headerClass: 'analysis-header-left',
          field: 'takeoffGrouping',
          width: 200,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'takeoff_Grouping_Name',
          },
          cellStyle: params =>
            projectlockedRow(params, 'takeoffGrouping', 'left'),
        },
        {
          headerName: 'Takeoff Source',
          headerTooltip: 'Takeoff Source',
          headerClass: 'header-left',
          field: 'takeoffSource',
          width: 150,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          cellStyle: params => projectlockedRow(params, 'takeoffSource', 'left'),
        },
        {
          headerName: 'Additional Description',
          headerTooltip: 'Additional Description',
          headerClass: 'header-center',
          field: 'additionalDescription',
          width: 180,
          cellRenderer: 'toolTipRenderer',
          cellStyle: params =>
            projectlockedRow(params, 'additionalDescription', 'center'),
          cellRendererParams: { type: 'analysisSheet' },
        },
        {
          headerName: 'Takeoff Description',
          headerTooltip: 'Takeoff',
          headerClass: 'header-left',
          field: 'takeoff',
          width: 400,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'takeoff_Name',
          },
          cellStyle: params => projectlockedRow(params, 'takeoff', 'left'),
        },
        {
          headerName: 'Calculation',
          headerTooltip: 'Calculation',
          headerClass: 'header-left',
          field: 'calculation',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'analysisSheet',
            name: 'calculation',
          },
          cellStyle: params =>
            strikeProjectAnalysisCalculations(params, 'calculation', 'left'),
        },
        {
          headerName: 'Quantity',
          headerTooltip: 'Quantity',
          headerClass: 'header-left',
          field: 'quantity',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          cellStyle: params => projectlockedRow(params, 'quantity', 'left'),
        },
        {
          headerName: 'Unit',
          headerTooltip: 'Unit',
          headerClass: 'header-left',
          field: 'unit',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          cellStyle: params => projectlockedRow(params, 'unit', 'left'),
          cellRendererParams: { type: 'analysisSheet' },
        },
        {
          headerName: 'Unit Cost',
          headerTooltip: 'Unit Cost',
          headerClass: 'header-right',
          field: 'unitCost',
          width: 120,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          cellStyle: params => projectlockedRow(params, 'unitCost', 'right'),
        },
        {
          headerName: 'Multiplier',
          headerTooltip: 'Multiplier',
          headerClass: 'header-right',
          field: 'multiplier',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { name: 'multiplier' },
          cellStyle: params => projectlockedRow(params, 'multiplier', 'right'),
        },
        {
          headerName: 'Total Cost',
          headerTooltip: 'Total Cost',
          headerClass: 'header-right',
          field: 'totalPrice',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          cellStyle: params => projectlockedRow(params, 'totalPrice', 'right'),
        },
        {
          headerName: 'Cost Source',
          headerTooltip: 'Cost Source',
          headerClass: 'header-left',
          field: 'costSource',
          width: 120,
          cellRenderer: 'toolTipRenderer',
          cellStyle: params => projectlockedRow(params, 'costSource'),
          cellRendererParams: { type: 'analysisSheet' },
        },
        {
          headerName: 'Time Factor',
          headerTooltip: 'Time Factor',
          headerClass: 'header-right',
          field: 'timeFactor',
          valueGetter: params => {
            return params.data.timeFactor && params.data.timeFactor !== null
              ? parseFloat(params.data.timeFactor).toFixed(4)
              : params.data.timeFactor
          },
          width: 120,
          cellRenderer: 'numberRender',
          cellRendererParams: {
            type: 'analysisSheet',
            fixed: 4,
            isCheck: true,
          },
          cellStyle: params => projectlockedRow(params, 'timeFactor', 'right'),
        },
        {
          headerName: 'Location Factor',
          headerTooltip: 'Location Factor',
          headerClass: 'header-right',
          field: 'locationFactor',
          valueGetter: params => {
            return params.data.locationFactor &&
              params.data.locationFactor !== null
              ? parseFloat(params.data.locationFactor).toFixed(3)
              : params.data.locationFactor
          },
          width: 130,
          cellRenderer: 'numberRender',
          cellRendererParams: {
            type: 'analysisSheet',
            fixed: 3,
            isCheck: true,
          },
          cellStyle: params =>
            projectlockedRow(params, 'locationFactor', 'right'),
        },
        {
          headerName: 'Estimate Method',
          headerTooltip: 'Estimate Method',
          headerClass: 'analysis-header-center',
          field: 'costMethod',
          width: 150,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          cellStyle: params => projectlockedRow(params, 'costMethod'),
        },
        {
          headerName: 'Construction Quality Factor',
          headerTooltip: 'Construction Quality Factor',
          headerClass: 'analysis-header-center',
          field: 'constructionQualityFactor',
          width: 200,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { name: 'constructionQualityFactor' },
          cellStyle: params =>
            projectlockedRow(params, 'constructionQualityFactor'),
        },
        {
          headerName: 'Condition Factor',
          headerTooltip: 'Condition Factor',
          headerClass: 'analysis-header-center',
          field: 'conditionFactor',
          width: 150,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { name: 'conditionFactor' },
          cellStyle: params => projectlockedRow(params, 'conditionFactor'),
        },
        {
          headerName: 'Estimate Cost',
          headerTooltip: 'Estimate Cost',
          headerClass: 'header-right',
          field: 'estimatedCost',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          cellStyle: params =>
            projectlockedRow(params, 'estimatedCost', 'right'),
        },
        {
          headerName: 'Trended Cost',
          headerTooltip: 'Trended Cost',
          headerClass: 'header-right',
          field: 'trendedCost',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { type: 'analysisSheet' },
          cellStyle: params => projectlockedRow(params, 'trendedCost', 'right'),
        },
        {
          headerName: 'Custom Indirect',
          headerTooltip: 'Custom Indirect',
          headerClass: 'header-right',
          field: 'customIndirect',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { type: 'analysisSheet', name: 'indirect' },
          cellStyle: params =>
            projectlockedRow(params, 'customIndirect', 'right'),
        },
        {
          headerName: 'Building Indirect',
          headerTooltip: 'Building Indirect',
          headerClass: 'header-right',
          field: 'buildingIndirect',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { type: 'analysisSheet', name: 'indirect' },
          cellStyle: params =>
            projectlockedRow(params, 'buildingIndirect', 'right'),
        },
        {
          headerName: 'Project Indirect',
          headerTooltip: 'Project Indirect',
          headerClass: 'header-right',
          field: 'projectIndirect',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { type: 'analysisSheet', name: 'indirect' },
          cellStyle: params =>
            projectlockedRow(params, 'projectIndirect', 'right'),
        },
        {
          headerName: 'Global Indirect',
          headerTooltip: 'Global Indirect',
          headerClass: 'header-right',
          field: 'globalIndirect',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { type: 'analysisSheet', name: 'indirect' },
          cellStyle: params =>
            projectlockedRow(params, 'globalIndirect', 'right'),
        },
        {
          headerName: 'Total Indirect',
          headerTooltip: 'Total Indirect',
          headerClass: 'header-right',
          field: 'totalIndirect',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { type: 'analysisSheet', name: 'indirect' },
          cellStyle: params =>
            projectlockedRow(params, 'totalIndirect', 'right'),
        },
        {
          headerName: 'RCN',
          headerTooltip: 'RCN',
          headerClass: 'header-right',
          field: 'rcn',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { searchType: 'string' },
          cellStyle: params => projectlockedRow(params, 'rcn', 'right'),
        },
        {
          headerName: 'Variance Factor',
          headerTooltip: 'Variance Factor',
          headerClass: 'analysis-header-center',
          field: 'varianceFactor',
          width: 130,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'analysisSheet', name: 'varianceFactor' },
          cellStyle: params => projectlockedRow(params, 'varianceFactor'),
        },
        {
          headerName: 'Allocated Cost',
          headerTooltip: 'Allocated Cost',
          headerClass: 'header-right',
          field: 'allocatedCost',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          cellRendererParams: { searchType: 'string' },
          cellStyle: params =>
            projectlockedRow(params, 'allocatedCost', 'right'),
          pinned: 'right',
        },
      ]
    },

    getData(params) {
      params.api.setSideBarVisible(false)
      params.api.openToolPanel('columns')
      params.api.setColumnDefs(this.columnDefs)
      params.api.setRowData(this.data)
      this.getColumnSettings(params)
      this.checkPreference()
    },

    getAnalysisSheet() {
      this.loading = true
      const url = projectAPIs.project.asset.newConstAnalysisSheet.takeoff(
        this.$route.params.id,
      )
      instance
        .get(url)
        .then(res => {
          this.data = _.get(res.data, 'result', [])
          if (this.data.length > 0) {
            this.data.forEach(element => {
              if (element.calculation) {
                element.formula = convertCalculationForTemplateAnalysisSheet(
                  element.calculation,
                  element,
                  this.dropdownInfo.calculation,
                )
                if (evaluateQantity(element.formula) < 0) {
                  element.quantity =
                    element.quantity < 0 ? null : element.quantity
                }
              }
            })
            this.gridOptions.api.setRowData(this.data)
          } else {
            this.data = []
            this.gridOptions.api.setRowData([])
            this.gridOptions.api.redrawRows()
          }
          this.height = calculateGridHeight(
            'NewAnalysisSheetTable',
            false,
            true,
            false,
            true,
          )
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    showDrawer() {
      this.visible = !this.visible
      this.gridOptions.api.setSideBarVisible(this.visible)
    },

    checkPreference() {
      this.gridOptions.columnApi.applyColumnState({
        state: this.tableState,
        applyOrder: true,
      })
    },

    getWindowSize(flag) {
      const height = calculateGridHeight('NewAnalysisSheetTable', true, true)
      if (flag) {
        if (height) {
          this.height = Number(height.split('px')[0]) - 14 + 'px'
        }
      } else {
        if (height) {
          this.height = Number(height.split('px')[0]) + 14 + 'px'
        }
      }
    },

    exportSheet() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSetting()
      }
    },

    gridColumnsChanged(value) {
      if (value && value.source === 'toolPanelUi') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        this.updateColumnSetting()
      }
    },

    sortChanged() {
      this.updateColumnSetting()
    },

    getColumnSettings(params) {
      const columnDetails = this.columnSettings.find(
        i => i.screenId === 14 && i.tableName === 'AnalysisSheet',
      )
      if (columnDetails && columnDetails.columnDetails) {
        this.tableState = JSON.parse(columnDetails.columnDetails)
      } else {
        this.tableState = this.gridOptions.columnApi.getColumnState()
      }
      const index = this.tableState.findIndex(i => i.colId === 'rcnld')
      if (index > -1) {
        this.tableState[index].hide = true
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: 14,
        tableName: tableName.project.analysisSheet,
        columnDetails: JSON.stringify(tableState),
      }
      this.$emit('updateColumnSettings', request)
    },

    messageRecieved(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.projectSidebarUpdated) {
        this.$root.$emit('projectSideBarUpdated', message)
      } else if (data.EventType === socketEvents.analysisSheetUpdated) {
        this.getAnalysisData()
      } else if (data.EventType === socketEvents.fileExported) {
        this.$root.$emit('message-received', message)
      } else if (data.EventType === socketEvents.takeoffReconcile) {
        this.$root.$emit('popupUpdation', false, true, null)
        if (data.Status === 'ERROR') {
          showNotification(
            'error',
            'Reconcile Analysis Sheet',
            _.get(data.Result, 'Message', ''),
          )
        } else {
          if (this.activeKey === '2') {
            this.getAnalysisSheet()
          }
        }
      }
    },

    reconcileSheet() {
      this.$root.$emit('popupUpdation', true, true, 'Please wait...')
      const url = projectAPIs.project.asset.newConstAnalysisSheet.reconcile(
        this.$route.params.id,
      )
      instance
        .post(url)
        .then(response => {
          if (response.data.message === 'Success') {
            this.$root.$emit('popupUpdation', false, true, null)
            this.getAnalysisSheet()
          }
        })
        .catch(err => {
          this.$root.$emit('popupUpdation', false, true, null)
          errorService(err)
        })
    },
  },
}
